import { useQuery } from 'react-query'

import { CacheKeys } from '../../helpers/cacheKeys'
import { fetchEmploymentHistoryItem } from '../../models/employment'

interface UseEmploymentHistoryProps {
  userId: string
  id: string
  enabled?: boolean
}

export const getEmploymentHistoryItemCache = (userId: string, id: string) =>
  `${CacheKeys.EMPLOYMENT_HISTORY_ITEM}-${userId}-${id}`

export function useEmploymentHistoryItem({ userId, id, enabled = true }: UseEmploymentHistoryProps) {
  const { data, isFetching, refetch, isLoading } = useQuery(
    getEmploymentHistoryItemCache(userId, id),
    () => fetchEmploymentHistoryItem(userId, id),
    {
      enabled,
      refetchOnWindowFocus: false,
      retry: true,
      retryDelay: (attempt) => Math.min(attempt > 1 ? 2 ** attempt * 1000 : 1000, 30 * 1000),
    }
  )

  return {
    employmentHistoryItem: data,
    refetch,
    isLoading,
    isFetching,
  }
}
